/* import __COLOCATED_TEMPLATE__ from './add-asset-from-library-modal.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import LSGModalBase from "../lsg/lsg-modal-dialog-base";
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

export default LSGModalBase.extend({
  /**
   * Register services
   */
  applicationCommandService: service('commands/application-commands'),
  applicationStateManager: service('state-managers/application'),
  companyCommandService : service('commands/company-commands'),
  store: service(),
  session: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * @type {Company}
     */
    company: null,

    /**
     * @type {User}
     */
    currentUser: null,

    /**
     * @param {Function}    Function will be called back when user clicks to add an asset.
     */
    onAssetAdded: function(asset) {}
  },

  /**
   * @inheritDoc
   */
  stateDefaults: {
    /**
     * @type {Boolean}    True when we are loading the company to get the assets.
     */
    isLoadingCompany: false
  },

  /**
   * @inheritDoc
   */
  _onInitializationComplete() {
    this.set('state.isLoadingCompany', true);

    let companyId = this.get('model.company.id');

    this.get('companyCommandService').loadCompany(
      companyId,
      ['assets.uploader']
    ).catch(e => {
      handleErrorResponseWithModal(
        this,
        e,
        'There was an error loading the assets for your company. Please refresh and try again.',
        '_onInitializationComplete -- error loading company ' + companyId,
      );
    }).finally(() => this.set('state.isLoadingCompany', false));
  },

  /**
   * @type {Ember.A<Asset>}
   */
  _availableAssets: computed('model.company.assets.[]', function() {
    return this.get('model.company.assets');
  }),

  actions: {
    /**
     * Called when the asset is clicked on.
     *
     * @param {Asset} asset
     */
    onAssetAddClicked: function(asset) {
      this.get('model.onAssetAdded')(asset);
    },

    closeModal() {
      closeModal(this);
    },
  }
});
